import { Star } from "lucide-react";

interface SellerRatingProps {
  rating: number;
  size?: "sm" | "md";
}

const SellerRating = ({ rating, size = "sm" }: SellerRatingProps) => {
  const stars = Math.min(5, Math.max(0, Math.round(rating)));
  const iconSize = size === "sm" ? "h-3 w-3" : "h-4 w-4";

  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={`${iconSize} ${i <= stars ? "text-amber-500 fill-amber-500" : "text-muted-foreground/30"}`}
        />
      ))}
    </div>
  );
};

export default SellerRating;
